import I18n from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";

export const LessonStatusField = () => (
  <Form.Item
    name="status"
    hideBorder
    hideDescription
    labelClassName="cursor-default"
    variant="extra-bottom-margin"
    label={I18n.t("courses.edit.lesson.lesson_status")}
  >
    <Form.RadioGroup
      fullWidth={false}
      labelOutside
      optionSize="sm"
      variant="radio"
      options={[
        {
          label: I18n.t("courses.edit.sections.statuses.draft"),
          value: "draft",
        },
        {
          label: I18n.t("courses.edit.sections.statuses.published"),
          value: "published",
        },
      ]}
    />
  </Form.Item>
);
